'use client';

import { MarketId } from '@drift/common';
import useGetOraclePriceForMarket from './useGetOraclePriceForMarket';

const useOraclePrice = (marketId: MarketId | undefined) => {
	const getOraclePrice = useGetOraclePriceForMarket();

	return getOraclePrice(marketId);
};

export default useOraclePrice;
